{
  "pt": {
    "installment": {
      "actions": {
        "bulkEdit": {
          "detail": "Detalhes",
          "reminder": "Lembretes"
        },
        "closeAllRows": "Fechar todas as linhas",
        "deleteCount": "Está prestes a eliminar a prestação {count}. Tem a certeza? | Está prestes a eliminar {count} prestações. Tem a certeza?",
        "delete_installments": "Eliminar prestação | Eliminar prestações",
        "edit": "Editar",
        "newInstallment": "Novo prazo da prestação",
        "openAllRows": "Abrir todas as linhas",
        "publish": "Publicar",
        "publishCustomer": "Publicar...",
        "save": "Atualização",
        "unpublish": "Cancelar a publicação",
        "updateStatus": "Atualizar o estado",
        "uploadInvoice": "Carregar fatura"
      },
      "attributes": {
        "amount": "Montante",
        "customer": "Cliente",
        "description": "Descrição",
        "due_date": "Prazo de entrega",
        "group_name": "Prestação",
        "paid_at": "Pago em",
        "status_deadline": "Estado",
        "unit": "Unidade"
      },
      "edit_actions": {
        "edit_amount": "Montantes",
        "edit_deadline": "Prazo de entrega",
        "edit_description": "Descrição",
        "edit_status": "Estado"
      },
      "labels": {
        "cantEditFractions": "Defina o estado da prestação como Rascunho para editar as regras.",
        "changeStatusRequested": "Alterar prestações do estado \"Rascunho\" para \"Facturado",
        "changeVisibility": "Alterar a visibilidade...",
        "change_amounts": "Modificar montantes",
        "clear_due_date": "Remover data de vencimento para todas as parcelas selecionadas",
        "clear_paid_at": "Remover data de pagamento para todas as parcelas selecionadas",
        "countEdit": "Editar prestação para 1 unidade | Editar prestação para {count} unidades",
        "created_at": "Criado {created_at}",
        "deleteExplanation": "Todas as prestações e facturas serão definitivamente retiradas da plataforma.",
        "deleteExplanationGroup": "Como pretende remover todas as prestações deste grupo de prestações, o grupo de prestações também será removido.",
        "details": "Detalhes",
        "edit": "Editar prestações",
        "editDueDate": "Editar prazo",
        "editInstallmentTerm": "Editar prestação",
        "excl_vat": "sem IVA",
        "giveNewAmount": "Dar em novo montante",
        "goToUnitInstallments": "Prestações unitárias",
        "installmentNoteExplainer": "Esta nota só é visível para os membros da equipa.",
        "installment_categories": "Categorias personalizadas",
        "invoices": "1 fatura | {count} facturas",
        "new_installment_fraction_category": "Categoria",
        "noDeadline": "Sem prazo",
        "notPublished": "Não publicado",
        "paid": "Pago",
        "published": "Publicado",
        "publishedCustomer": "Publicado para o cliente",
        "publishingForCustomers": "Tem a certeza?",
        "selectOne": "Selecionar pelo menos 1 prestação",
        "selected": "{selected} prestação selecionada. | {selected} prestações selecionadas.",
        "setDueDate": "Fixar prazo",
        "statusExplained": "O que significa cada estado da prestação?",
        "status_deadline": "Estado",
        "statuses": {
          "draft": "Projeto",
          "expected": "Esperado",
          "overdue": "Atrasado",
          "paid": "Pago",
          "requested": "Facturado"
        },
        "toBePaid": "A pagar",
        "total": "Total",
        "unitInstallmentsWillBeShownHere": "As prestações unitárias serão apresentadas aqui",
        "unpublishingForCustomers": "Anular a publicação de prestações para o cliente. Tem a certeza?",
        "updateStatusCount": "Estado de atualização para 1 prestação | Estado de atualização para {count} prestações",
        "uploadInvoiceCount": "Carregar fatura para 1 prestação | Carregar fatura para {count} prestações",
        "uploadInvoiceUnit": "Carregar a fatura para {unit_name}",
        "vat": "IVA",
        "vat_with_percentage": "{percentage}% IVA",
        "view_list": "Lista"
      },
      "legend": {
        "installmentDraft": "Projeto de prestação",
        "installmentDraftAfterDueDate": "Projeto de prestação",
        "installmentExpired": "Prazo expirado",
        "installmentPaid": "Prestação já paga",
        "installmentPaidAfterDue": "Prestação paga fora do prazo",
        "installmentRequested": "Facturado",
        "reminders": {
          "active": "Pelo menos 1 lembrete foi definido",
          "none": "Não foram definidos lembretes"
        }
      },
      "placeholders": {
        "customers": {
          "documents": {
            "subtitle": "Todos os documentos de prestação serão apresentados aqui.",
            "title": "Ainda não há documentos!"
          },
          "new": {
            "subtitle": "Em breve, novos episódios!"
          }
        }
      },
      "sort_options": {
        "due_date": "Prazo de entrega",
        "due_date asc": "Prazo mais distante primeiro",
        "due_date desc": "Prazo mais próximo primeiro",
        "group_name": "Nome",
        "group_name asc": "Nome A-Z",
        "group_name desc": "Nome Z-A",
        "status": "Estado",
        "status asc": "Estado A-Z",
        "status desc": "Estado Z-A",
        "updated_at asc": "A atualização mais recente primeiro",
        "updated_at desc": "Primeira atualização mais recente"
      },
      "validation": {
        "needNumber": "Necessita de um número (por exemplo, 8400.5)"
      }
    }
  }
}